import {benAdminActionTypes} from "../actions/actionTypes";

const initialState = {
    name: '',
    lastName: '',
};


export const benAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case benAdminActionTypes.SET_BEN_ADMIN_NAME:
            return {
                ...state,
                name: action.payload
            };
        case benAdminActionTypes.SET_BEN_ADMIN_LAST_NAME:
            return {
                ...state,
                lastName: action.payload
            };
        case benAdminActionTypes.RESET_BEN_ADMIN_DATA:
            return {...initialState}
        default:
            return state
    }
};